(function () {
  'use strict';

  /**
   * Flickity sets aria-hidden="true" on inactive cells but leaves their
   * focusable descendents in the tab order. Mirror the aria-hidden state
   * onto tabindex so screen readers and the visible focus order agree.
   *
   * Scoped: we only attach a MutationObserver to .flickity-slider elements
   * (not document.body) and only after Flickity has actually initialized,
   * so this script does no work on pages without carousels.
   */

  function syncCell(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var focusables = cell.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    for (var i = 0; i < focusables.length; i++) {
      var el = focusables[i];
      if (hidden) {
        if (!el.hasAttribute('data-orig-ti')) {
          el.setAttribute('data-orig-ti', el.getAttribute('tabindex') || '');
        }
        if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-orig-ti')) {
        var orig = el.getAttribute('data-orig-ti');
        if (orig === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', orig);
        el.removeAttribute('data-orig-ti');
      }
    }
  }

  function attachToSlider(slider) {
    if (slider.dataset.a11ySyncAttached === '1') return;
    slider.dataset.a11ySyncAttached = '1';

    // Initial pass.
    var children = slider.children;
    for (var i = 0; i < children.length; i++) syncCell(children[i]);

    // Watch only this one slider for aria-hidden changes on its direct children.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.target.parentElement === slider) syncCell(m.target);
      }
    });
    observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    var sliders = document.querySelectorAll('.flickity-enabled .flickity-slider');
    for (var i = 0; i < sliders.length; i++) attachToSlider(sliders[i]);
  }

  // Run a few times after load to catch sliders that Flickity initialises
  // late (e.g. inside <product-recommendations> after fetch). Bail out once
  // we've found and attached to all visible sliders.
  function scheduleRetries() {
    var attempts = 0;
    var max = 6;
    function tick() {
      init();
      attempts++;
      if (attempts < max) setTimeout(tick, 500);
    }
    tick();
  }

  if (document.readyState === 'complete') {
    setTimeout(scheduleRetries, 200);
  } else {
    window.addEventListener('load', function () { setTimeout(scheduleRetries, 200); }, { once: true });
  }
})();
